/**
 * Generated by orval 🍺
 * Do not edit manually.
 * [DEV] Backend
 * OpenAPI spec version: 0.1.0
 */

export type FilterIsNegativeIntentV2Kind =
  (typeof FilterIsNegativeIntentV2Kind)[keyof typeof FilterIsNegativeIntentV2Kind];

export const FilterIsNegativeIntentV2Kind = {
  is_negative_intent_v2: 'is_negative_intent_v2',
} as const;
